class SeoDetails extends HTMLElement {
  connectedCallback() {
    this.description = this.querySelector('[data-seo-description]')
    this.expandBtn = this.querySelector('[data-seo-expand]')
    this.collapseBtn = this.querySelector('[data-seo-collapse]')

    if (!this.description || !this.expandBtn || !this.collapseBtn) return

    this.handleResize = () => this.update()
    this.handleExpand = () => this.toggle(true)
    this.handleCollapse = () => this.toggle(false)

    this.expandBtn.addEventListener('click', this.handleExpand)
    this.collapseBtn.addEventListener('click', this.handleCollapse)
    window.addEventListener('resize', this.handleResize)

    this.update()
  }

  disconnectedCallback() {
    this.expandBtn?.removeEventListener('click', this.handleExpand)
    this.collapseBtn?.removeEventListener('click', this.handleCollapse)
    window.removeEventListener('resize', this.handleResize)
  }

  getCollapsedHeight() {
    const styles = getComputedStyle(this.description)
    const lines = parseFloat(styles.getPropertyValue('--seo-lines-to-show')) || 8
    const lineHeight = parseFloat(styles.lineHeight) || 24

    return lines * lineHeight
  }

  update() {
    const isExpanded = this.description.classList.contains('is-expanded')
    if (isExpanded) this.description.classList.remove('is-expanded')

    const hasOverflow =
      this.description.scrollHeight > this.getCollapsedHeight() + 2

    if (isExpanded) this.description.classList.add('is-expanded')

    this.classList.toggle('has-overflow', hasOverflow)

    if (!hasOverflow) {
      this.description.classList.remove('is-expanded')
    }

    const expanded = hasOverflow && this.description.classList.contains('is-expanded')

    this.expandBtn.classList.toggle('hidden', !hasOverflow || expanded)
    this.collapseBtn.classList.toggle('hidden', !hasOverflow || !expanded)

    this.expandBtn.setAttribute('aria-expanded', expanded)
    this.collapseBtn.setAttribute('aria-expanded', expanded)
  }

  toggle(state) {
    this.description.classList.toggle('is-expanded', state)
    this.update()
  }
}

customElements.define('seo-details', SeoDetails)